import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

// import ErrorBoundary from 'core/ui/components/ErrorBoundary';

const PublicRoute = ({ component: Component, layout: Layout, ...rest }) => (
  // <ErrorBoundary>
    <Route
      {...rest}
      render={props => {
        return Layout ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Component {...props} />
        );
      }}
    />
  // </ErrorBoundary>
);

PublicRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  layout: PropTypes.elementType.isRequired,
};

export default PublicRoute;
